import React from 'react';
import { InputValue } from './donate-form-utils';
import { DonateFormConfig } from './DonateFormContextProvider';

interface DonateFormContextState {
    formState: {[key in string]: InputValue};
    canSubmitForm: boolean;
    config: DonateFormConfig;
    updateFormState: (name: string, value: string) => void;
}

const defaultContext: DonateFormContextState = {
    formState: {},
    canSubmitForm: false,
    config: {legacyUrl: '', charityKey: '', stripePublishableKey: '', isAppleGooglePayEnabled: false, isPayPalEnabled: false},
    updateFormState: () => {},
}

export const DonateFormContext = React.createContext<DonateFormContextState>(defaultContext);
